/** Must stay in sync with RPC / DB expectations for A/B theme tests. */
export const AB_SESSION_KEY = 'rif-ab-theme-variant';
